import { create } from 'zustand'
import { cleanEvent, type FeedbackEvent } from '@/services/feedbackContext/allowlist'
import { pruneEvents, pushEvent } from '@/services/feedbackContext/ring'

/**
 * The recent events a Help & feedback report may carry (SA-1304). Every event is cleaned through
 * the allowlist before it is kept; the ring holds at most 50, none older than ten minutes. Emptied
 * on every identity change (`identityScope.RESET_TO_INITIAL`). Nothing here is ever sent: the panel
 * takes a snapshot when the person presses Send.
 */
interface FeedbackContextState {
  events: FeedbackEvent[]
  /** Clean and keep one event; an event the allowlist refuses is not kept. */
  record: (kind: string, raw: Record<string, unknown>, now?: number) => void
  /** The events still inside the ring's bounds, oldest first. */
  snapshotEvents: (now?: number) => FeedbackEvent[]
}

export const useFeedbackContextStore = create<FeedbackContextState>((set, get) => ({
  events: [],
  record: (kind, raw, now = Date.now()) => {
    const event = cleanEvent(kind, { at: now, ...raw })
    if (!event) return
    set({ events: pushEvent(get().events, event, now) })
  },
  snapshotEvents: (now = Date.now()) => pruneEvents(get().events, now),
}))
